import { useState } from 'react';
import { NestedHome, NestedProject } from '@habity/types';
import { getAPI } from '~/lib/api';
import { useToast } from '~/lib/toasts';
import { capitalize } from 'lodash';

export const useVitec = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();

  const syncEstate = async (home?: NestedHome | null, schedule = true) => {
    const { id } = home || {};
    setIsLoading(true);
    const { data: newHome } = await getAPI(
      `/providers/vitec/estate/sync/${id}${schedule ? '/schedule' : ''}`
    );
    setIsLoading(false);

    showToast({
      title: `Bostaden har schemalagts för synk med ${capitalize(
        home?.provider || 'vitec'
      )}`,
      description: `${home?.address?.street || id} synkas med ${
        home?.provider_id || id
      }. Synkroniseringen kommer att ske inom 1 minut.`
    }, { status: 'success' });

    return newHome;
  };

  const syncProject = async (project?: NestedProject | null, schedule = true) => {
    const { id } = project || {};
    setIsLoading(true);
    const { data: newProject } = await getAPI(
      `/providers/vitec/project/sync/${id}${schedule ? '/schedule' : ''}`
    );
    setIsLoading(false);

    showToast({
      title: `Projektet har schemalagts för synk med ${capitalize(
        project?.provider || 'vitec'
      )}`,
      description: `${project?.name || id} synkas med ${
        project?.provider_id || id
      }. Synkroniseringen kommer att ske inom 1 minut.`
    }, { status: 'success' });

    return newProject;
  };

  return { isLoading, setIsLoading, syncEstate, syncProject };
};
